import { Button } from '@octopus-do/octopus-storybook'
import { closeModal } from '@storeOld/reducers/ui'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { DASHBOARD_LINK } from '@/components/Router/constants'
import API from '../../../api'
import Reasons from './components/Reasons'
import initialState from './initialState'
import type { ChangeEvent, Options } from './types'
import './styles.scss'

const Cancel: React.FC = () => {
  const [options, setOptions] = useState<Options>(initialState)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onChange = (obj: ChangeEvent) => {
    const payload = [...options]

    payload.forEach(function iterate(item) {
      if (item.id === obj.id) {
        if (obj.type === 'checkbox') {
          item.checked = obj.checked
        } else if (obj.type === 'input') {
          if (item.input) {
            item.input.value = obj.value
          }
        }
      }

      Array.isArray(item.options) && item.options.forEach(iterate)
    })

    setOptions(payload)

    const findChecked = payload.find((item) => item.checked)

    if (findChecked) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }

  const onSubmit = () => {
    let payload = [...options]

    setError('')

    // @ts-expect-error
    payload = payload
      .map(function iterate(item) {
        if (!item.checked) {
          return null
        }

        if (!item.options) {
          const newItem = {
            label: item.label,
          }

          if (item.input) {
            // @ts-expect-error
            newItem.options = item.options
              ? // @ts-ignore
                [...newItem.options, item.input.value]
              : [item.input.value]
          }

          return newItem
        }

        const options = item.options.filter((i) => {
          // @ts-expect-error
          return i.checked || (i.input && i.input.value.length)
        })

        const newItem = {
          label: item.label,
        }

        if (item.input) {
          // @ts-expect-error
          newItem.options = [item.input.value]
        }

        // @ts-expect-error
        let newOptions = []

        if (options.length) {
          newOptions = options.map((i) => {
            if (i.input) {
              return i.input.value
            }

            return i.label
          })
        }

        // @ts-expect-error
        newItem.options = newItem.options // @ts-ignore
          ? [...newOptions, ...newItem.options] // @ts-ignore
          : newOptions

        return newItem
      })
      .filter((item) => item)

    API.Auth.cancel({
      survey: payload,
    })
      .then(() => {
        navigate(DASHBOARD_LINK)
        setSuccess(true)
      })
      .catch((err) => {
        if (err.message === 'Authentication Required') {
          setError('You must be logged in to cancel your subscription.')
        } else {
          setError('Something went wrong. Please try again.')
        }
      })
  }

  return (
    <div className="survey-cancel">
      <div className="head">
        {/*@ts-ignore*/}
        {/*<img src={octopus} alt="octopus" />*/}

        <div>Subscription is canceled</div>
      </div>

      <div className="list">
        <p className={success ? 'success' : ''}>
          {success
            ? 'Thank you. We really appreciate your time and do our best to deliver best in class product.'
            : `It's sad to see you go. Please tell us why you're cancelling, maybe we can help!`}
        </p>

        {!success && <Reasons options={options} onChange={onChange} />}
      </div>

      {success ? (
        <Button label="Ok" onClick={() => dispatch(closeModal())} />
      ) : (
        <Button label="Submit" disabled={disabled} onClick={onSubmit} />
      )}

      {error.length > 0 && <div className="survey-cancel-error">{error}</div>}
    </div>
  )
}

export default Cancel
